export { RESOURCE_NAME } from '@esentai/core/features/productCategory/consts';

export const ROUTE_PATH = '/product-category';

export const FEATURE_NAME = 'productsCategoryPage';
